<template>
    <img class="logo" v-bind:width="width" src="@/assets/logo.svg" alt="JXL Studio Logo">
</template>
<script>
export default {
    name: 'Logo',
    props: {
        width:{
            type: Number,
            default: 500
        }
    }
}
</script>
